// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aligner-OqnRyH{z-index:99;position:absolute;top:-24px}.tip-L3yToP{position:absolute;bottom:100%;right:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aligner": `aligner-OqnRyH`,
	"tip": `tip-L3yToP`
};
export default ___CSS_LOADER_EXPORT___;
